import { Poppins, Quicksand } from 'next/font/google';
import React, { Component } from 'react'
const quickSand = Quicksand({weight:"500",subsets:['latin']});
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});
export default class CourseEligibility extends Component {
  render() {
    const {EligibilityData,heading3}=this.props
    return (
      <>
      <section>

<div className='container'>
<div className='mt40 '>
    <h2 className={`fs40 lh5 ylw-clr mfs-20 tac ${popins.className}`}>{heading3}</h2>

    {EligibilityData.map((items,index)=>{
        return(
<div className={``} key={index}>
    <h6 className={`fs-20 dim-clr con-1000 tac mtal  pdt25 mpdt10 mfs14 lhs20 ${extraPopins.className}`}>{items.cnt}</h6>
</div>
)
})}
</div>
</div>


      </section>
      
      
  <style jsx>
{`


.con-1000{
 max-width:1050px;
 width:100%;
 height:100%;
 margin:0 auto;
}

`}

  </style>    
      
      
      </>
    )
  }
}
